import { UserSettings } from 'src/app/core/models/user-settings.model';

export interface UserSettingsState {
  loading: boolean;
  error: any;
  userSettings: UserSettings | null;
}

export const initialState: UserSettingsState = {
  loading: false,
  error: null,
  userSettings: null
};
